module.exports = __webpack_public_path__ + "images/iphone/int_logo.png";